"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
exports.__esModule = true;
var ramda_1 = require("ramda");
var defaultProps = [
    'autocomplete',
    'autofocus',
    'dirname',
    'disabled',
    'form',
    'formnovalidate',
    'list',
    'max',
    'maxLength',
    'min',
    'multiple',
    'name',
    'pattern',
    'placeholder',
    'readonly',
    'required',
    'size',
    'step',
    'type',
    'value',
];
var byType = {
    file: ['accept'],
    checkbox: ['checked'],
    radio: ['checked'],
    submit: ['formaction', 'formenctype', 'formmethod', 'formtarget'],
    image: [
        'alt',
        'formaction',
        'formenctype',
        'formmethod',
        'formtarget',
        'height',
        'src',
        'width',
    ]
};
var sanitizeProps = function (props) {
    var type = props.type, rest = __rest(props, ["type"]);
    return __assign(__assign({}, ramda_1.pick(defaultProps, __assign({ type: type }, rest))), (byType[type] && ramda_1.pick(byType[type], rest)));
};
exports["default"] = sanitizeProps;
//# sourceMappingURL=input.js.map